import React from 'react';
import Grid from "@mui/material/Grid";

const FlexGrid = ({children,sx,...otherProps}) => {
    return (
        <Grid sx={{display: 'flex', alignItems: 'center',...sx}} {...otherProps}>
            {children}
        </Grid>
    );
};

export default FlexGrid;
